var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D6CE6",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 3.875h-1.219v-.938a.937.937 0 1 0-1.875 0v.938H8.796v-.938a.937.937 0 1 0-1.874 0v.938H5.75A3.754 3.754 0 0 0 2 7.625V18.25A3.754 3.754 0 0 0 5.75 22h4.172a.937.937 0 1 0 0-1.875H5.75a1.877 1.877 0 0 1-1.875-1.875V7.625c0-1.034.841-1.875 1.875-1.875h1.172v.938a.937.937 0 1 0 1.875 0V5.75h6.359v.938a.937.937 0 1 0 1.875 0V5.75h1.219c1.034 0 1.875.841 1.875 1.875v2.344a.937.937 0 1 0 1.875 0V7.625a3.754 3.754 0 0 0-3.75-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.883 17.215h8.804l-1.947 1.947a.888.888 0 0 0 0 1.25.88.88 0 0 0 .622.26.88.88 0 0 0 .623-.26l3.453-3.452a.888.888 0 0 0 0-1.25l-3.453-3.453a.888.888 0 0 0-1.25 0 .888.888 0 0 0 0 1.251l1.952 1.942H9.883a.883.883 0 1 0 0 1.765z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnDate);
export default __webpack_public_path__ + "static/media/return-date.520198adef56285dd7c5868ca5761147.svg";
export { ForwardRef as ReactComponent };